'use client';

import { useTranslations } from 'next-intl';
import styles from './index.module.scss';
import { Montserrat } from 'next/font/google';
import { Button } from '@components/ui/button';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { useHeroNeonGrid } from './useHeroNeonGrid';

const montserrat = Montserrat({ subsets: ['latin'] });

const HeroNeonGrid: React.FC = () => {
  const { canvasRef } = useHeroNeonGrid();
  const t = useTranslations('hero');

  return (
    <div className={styles.container}>
      <canvas ref={canvasRef} className={styles.canvas}></canvas>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 1 }}
        className={`${styles.content} ${montserrat.className}`}
      >
        <motion.h1>{t('welcome')}</motion.h1>
        <motion.h2>{t('innovation')}</motion.h2>
        <motion.div>
          <Button asChild>
            <Link href="#services">{t('getStarted')}</Link>
          </Button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default HeroNeonGrid;
